module.exports = __webpack_public_path__ + "media/images/emoticons/chair-f4413fcc9f929cc4fdc262bc88bdf49a.gif";